import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

/**
 * Function to call ContractAlert Alert API
 * @returns 
 */
export async function contractDetailsAPI(requestPayload) {

  try {
    return await authenticatedFetch(URL.ContractAlert, {
      method: "POST",
      body: JSON.stringify(requestPayload)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

export async function contractAgingAPI(requestObj) {
  try {
    return await authenticatedFetch(URL.agingAPI, {
      method: "POST",
      body: JSON.stringify(requestObj)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

/**
 * Function to call ContractAlert P2 Alert API
 * @returns 
 */
export async function contractDetailsPR2API(requestPayload) {

  try {
    return await authenticatedFetch(URL.ContractPR2Alert, {
      method: "POST",
      body: JSON.stringify(requestPayload)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}